import { render } from "./VariableSelector.vue?vue&type=template&id=87bdeab2&scoped=true"
import script from "./VariableSelector.vue?vue&type=script&lang=js"
export * from "./VariableSelector.vue?vue&type=script&lang=js"

import "./VariableSelector.vue?vue&type=style&index=0&id=87bdeab2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87bdeab2"]])

export default __exports__